'use client';
import { PortableText, PortableTextComponents } from '@portabletext/react';
import { type PortableText as PortableTextType } from '@/sanity/schemaTypes/portableText/portableTextType';
import { type LinkInternal as LinkInternalType } from '@/sanity/schemaTypes/objects/link/linkInternalType';
import { type LinkExternal as LinkExternalType } from '@/sanity/schemaTypes/objects/link/linkExternalType';
import LinkInternal from './LinkInternal';
import LinkExternal from './LinkExternal';
import { ImageFeatures } from '@/sanity/schemaTypes/objects/module/imageFeaturesType';

export default function CustomPortableText({
  value,
  className
}: {
  value: PortableTextType;
  className?: string;
}) {
  const components: PortableTextComponents = {
    marks: {
      linkInternal: ({ children, value }: { children: any; value?: LinkInternalType }) => {
        return value ? <LinkInternal link={value}>{children}</LinkInternal> : children;
      },
      linkExternal: ({ children, value }: { children: any; value?: LinkExternalType }) => {
        return value ? <LinkExternal link={value}>{children}</LinkExternal> : children;
      }
    },
    types: {
      images: ({ value }: { value: ImageFeatures }) => {
        return <div className="bg-red-500 text-white">IMAGES</div>;
      }
    }
  };

  return (
    <>
      <PortableText components={components} value={value} />
      <div className="clear-both"></div>
    </>
  );
}
